import React from 'react';
import { UserRoleInterface } from 'types/global';
import SignUpForm from 'modules/SignUp/components/SingUpForm';
import { RECRUITER } from 'constants/index';
import usePageMeta from '../hooks/usePageMeta';

const SignUp: React.FC<UserRoleInterface> = ({ userRole }): JSX.Element => {
  const isRecruiter = userRole === RECRUITER;
  usePageMeta({
    title: isRecruiter ? 'Recruiter Sign Up — BoostHiring' : 'Employer Sign Up — BoostHiring',
    description: isRecruiter
      ? 'Register as a recruiter on BoostHiring. Submit candidates, earn placement fees, and grow your recruiting business.'
      : 'Register as an employer on BoostHiring. Post jobs for free, connect with recruiters, and hire top talent.',
    canonical: isRecruiter
      ? 'https://boosthiring.ca/recruiter/signup'
      : 'https://boosthiring.ca/employer/signup',
  });

  return <SignUpForm userRole={userRole} />;
};

export default SignUp;
